/*  global _ */
const EventBus = window.VueEventBus

import config from '../../lib/config'
import { getQS } from '../../lib/utils'
import { getNow, parseDateTime } from '../../lib/dates'

const {
  supercharged,
  clubspeed,
  TIMEZONE,
  NO_MIN_DATE = false,
  FIRST_DAY_FOR_BOOKING = 0,
  DAYS_AVAILABLE_FOR_BOOKING = null
} = config
const { races: {ninja: raceSettings = {}} = {} } = supercharged

let {DEFAULT_BOOKING_TIMEOUT: timerTimeout = 1800, DEFAULT_BOOKING_BUFFER: bookingBuffer = 30} = config
const qs = getQS() || {}
timerTimeout = (1 * qs.timeout) || (timerTimeout - 10)

import PageMixins from '../../components/_mixins/pages'
import RaceMixins from '../../components/_mixins/races'
import CartMixins from '../../components/_mixins/location-checkout'
import ScrollMixins from '../../components/_mixins/scroller'
import PersonalDetailsMixins from '../../components/_mixins/personal-details'
import StepsMixins from './steps'
import BookingMixin from '../../components/_mixins/booking'
const mixins = [
  RaceMixins,
  PageMixins,
  CartMixins,
  ScrollMixins,
  PersonalDetailsMixins,
  StepsMixins,
  BookingMixin
]

import WouldYouLikeTo from '../../components/parts/would-you-like-to'

import AgreeToTerms from '../../components/parts/AgreeToTerms'
import TimeslotSelectorBox from './parts/timeslot-selector-box'
import MiniCart from './parts/mini-cart'

import {Datetime} from 'vue-datetime-extended'
import 'vue-datetime-extended/dist/vue-datetime-extended.css'

const components = {
  AgreeToTerms,
  Datetime,
  TimeslotSelectorBox,
  MiniCart,
  WouldYouLikeTo
}

const now = getNow(TIMEZONE)
const today = now.plus({ days: FIRST_DAY_FOR_BOOKING || 0 })
// const today = DateTime.local().plus({ days: -1 })
const weekLater = today.plus({ days: (DAYS_AVAILABLE_FOR_BOOKING || 7) - 1 })

export default {
  name: 'page-book-ninja-wipeout',
  settings: 'page.ninja',
  translations: 'page.ninja',
  components,
  mixins,
  data() {
    return {
      isOneRaceType: true,
      timeZone: TIMEZONE,
      minDate: NO_MIN_DATE ? null : today.toISODate(),
      maxDate: weekLater.toISODate(),
      disabledDates: [],
      infoImageUri: config.TIMESLOT_INFO_IMAGE,
      formValidated: false,
      showBookGroupEventPrompt: false,
      showHoursLimitPrompt: false,
      hasRacersChanged: false,
      racersChangedAlert: '',
      freezeSlotRetrieval: false,
      editMode: false,
      editingId: null,
      numRacers: 0,
      numHours: 0,
      sockProposedId: null,
      sockProposedCount: 0,
      contactPhone: supercharged.phone_with_extension || '774-847-9010,101',
      isAddingToCart: false,
    }
  },
  computed: {
    contactPhoneExt() {
      return this.contactPhone.replace(',', ' ext. ')
    },
    moreThanOrEightRacers() {
      return this.totalPlayers >= 8
    },
    productIds() {
      return JSON.parse(this.raceSettings.products || '[]')
    },
    maxRacers() {
      return this.raceSettings.max_racers || 75
    },
    maxAccommodation() {
      return this.raceSettings.max_accommodation || this.raceSettings.max_racers || 150
    },
    racersLimit() {
      return this.maxRacers
    },
    hoursLimit() {
      return this.raceSettings.max_hours || 15
    },
    moreThanHoursLimit() {
      return this.numberOfHours > this.hoursLimit
    },
    moreThanRacersLimit() {
      return this.totalPlayers > this.racersLimit
    },
    isGroupEventDetected () {
      return this.moreThanRacersLimit
    },
    raceSettings() {
      return raceSettings || {}
    },
    readyForSocksSelection() {
      return this.hasSocksProducts && !this.racerNotSet
    },
    socksProducts() {
      return this.getSettings('socksProducts') || []
    },
    hasSocksProducts() {
      return !_.isEmpty(this.socksProducts)
    },
    socksProductsWithID() {
      return _.transform(this.socksProducts, (items, item) => items[item.productId] = item, {})
    },
    sockProposed() {
      return this.socksProductsWithID[this.sockProposedId] || {}
    },
    sockProposedAmount() {
      return ((1 * this.sockProposed.price) || 0) * ((1 * this.sockProposedCount) || 0)
    },
    proposedSocks() {
      return this.productAccessories
    },
    hasProposedSocks() {
      return !_.isEmpty(this.proposedSocks)
    },
    disableWeekDays() {
      return this.$$s('disableWeekDays', null)
    },
    disableDates() {
      return this.$$s('disableDates', null)
    },
  },
  watch: {
    showMiniCart(newValue, oldvalue) {
      if (this.preventTimerStartInEditMode) {
        return
      }
      if (newValue) {
        if (!this.timerIsRunning) {
          const holdStartsAt = this.holdStartsAt = getNow().toSeconds()
          this.holdEndsAt = (1 * holdStartsAt) + timerTimeout
          this.startTimer(timerTimeout)
        }
        if (!this.holdStartsAt || !this.holdEndsAt) {
          this.holdStartsAt = parseDateTime(this.timerStartTime).toSeconds()
          this.holdEndsAt = parseDateTime(this.timerEndTime).toSeconds()
        }
      } else {
        if (!this.needsToShowTimer) {
          this.stopTimer()
        }
      }
    },
    async selectedDate(newValue, oldValue) {
      if (_.isObject(newValue)) {
        newValue = null
      }
      if (newValue && !this.freezeSlotRetrieval) {
        newValue = ('' + newValue).trim()
        const timeslots = await this.retrieveTimeslots(newValue)
      }
      this.freezeSlotRetrieval = false
    },

    totalPlayers(newValue, oldValue) {
      const slotted = this.totalRacersSlottedGrouped || 0
      this.hasRacersChanged = false
      this.racersChangedAlert = ''

      if (this.isGroupEventDetected) {
        newValue = 0
      }
    },
    readyForSocksSelection(newValue, oldValue) {
      this.sockProposedCount = this.totalPlayers
    },
    numRacers(val, oldVal) {
      this.watchNumRacers()
    },
    numberOfAdults(val, oldVal) {
      if (this.isHydratingData) {
        this.numRacers = val
      }
      this.watchNumRacers()
    },
    numHours(val, oldVal) {
      this.watchNumHours()
    },
    numberOfHours(val, oldVal) {
      if (this.isHydratingData) {
        this.numHours = val
      }
      this.watchNumHours()
    }
  },
  async created () {
    this.hideGlobalTimer(true)
    this.mayResetCountdownTimer()
    this.enableSlotGrouping(true)
    this.allowToRaceSeparately(false)
    this.setRaceTypes(['ninja'])
    this.raceTitle = 'Ninja Wipeout'
    this.raceType = 'ninja'
    this.editRoute = 'racewaybooking.ninja'
    this.hasGroupedSlots = true
    this.usePackages = false
    this.maxDate = config.DAYS_AVAILABLE_FOR_BOOKING ? this.maxDate : null

    this.sockProposedId = (_.head(this.socksProducts) || {}).productId || null
    const vm = this
    EventBus.$on('cart-item-edit-reservations', async (item, cartItem, cart) => {
      await this.hydrateRacesFromCart(item, cartItem, cart)
      this.$nextTick(() => {
        this.scrollTo('.racers-date-input-box')
      })
    })
    EventBus.$on('cart-item-added-reservations', (item, cartItem, cart) => {

    })
    EventBus.$on('cart-item-deleted-reservations', (item, cartItem, cart) => {
      this.unsetLocalCartItem(item)
      this.clearProductAccessories()
      this.cleanTimeslots()
      this.$nextTick(() => {
        this.scrollTo('.racers-date-input-box')
      })
    })
    EventBus.$on('cart-cleaned', cart => {
      this.clearProductAccessories()
      this.cleanTimeslots()
      this.clearLocalCart()
      this.$nextTick(() => {
        this.scrollTo('.racers-date-input-box')
      })
    })
    EventBus.$on('cart-go-back', cart  => {
      // vm.goBackToRaceShop()
    })
    EventBus.$on('cart-get-item-description', (item, cartItem, cart) => {
     // .selected-time-slots
    })
   EventBus.$on('timer.timeout', id => {
     const canAutoRemove = this.autoRemoveCartItemOnTimeout
     if (canAutoRemove) {
       this.cleanExistingItems()
     } else {
       this.cleanSelectedTimeslots()
     }
      let message = 'Time to hold your selection for reservation has expired.'
      if (this.editMode && canAutoRemove) {
        message += ' Your cart item has been removed.'
      }
      message += ' Please start over again!'
      this.$nextTick(() => {
        this.scrollTo('.racers-date-input-box')
      })
      this.alert(message, {classes: 'text-danger'})
    })

    await this.setEditItem(qs.item || this.$route.query.item)

    if (this.editMode) {
      this.editingId = this.raceEditItem.id
      const expired = this.hasExpired(this.raceEditItem)
      if (expired) {
        EventBus.$emit('timer.timeout', this.currentLocationId)
        this.mayResetCountdownTimer()
      }
      if (!expired || !this.autoRemoveCartItemOnEditTimeout) {
        EventBus.$emit('cart-item-edit-reservations', this.raceEditItem)
      }
    }
  },
  methods: {
    async setEditItem() {
      // this.editMode = !!this.raceEditItem && this.raceEditItem.attributes.raceType === this.raceType
      const id = decodeURIComponent(qs.item || this.$route.query.item)
      if (id) {
        const item = this.cartItems[id]
        debugLog({id, item, raceType: this.raceType})
        if (item && item.type === 'race-reservations' && _.get(item, 'attributes.form.raceType') === this.raceType) {
          await this.setRaceEditItem(item)
          this.editMode = true
        }
      }
    },
    watchNumHours(event) {
      const newValue = Math.max(0, Math.round(this.numHours) || 0)
      this.numHours = newValue
      this.askAndRemoveSelectedTimeSlot('change in the number of hours',
        () => {
          this.numberOfHours = newValue
          this.$nextTick(() => {
            this.showHoursPrompts()
          })
        },
        () => {
          this.numHours = this.numberOfHours
        },
      );
    },
    watchNumRacers(event) {
      const newValue = Math.max(0, Math.round(this.numRacers) || 0)
      this.numRacers = newValue
      this.askAndRemoveSelectedTimeSlot('change in the number of participants',
        () => {
          this.numberOfAdults = newValue
          this.$nextTick(() => {
            this.showPrompts()
          })
        },
        () => {
          this.numRacers = this.numberOfAdults
        },
        () => {
         this.clearProductAccessories()
        }
      );
    },
    watchChosenDate(newValue) {
      if (_.isObject(newValue)) {
        newValue = null
      }
      if (newValue) {
        this.askAndRemoveSelectedTimeSlot('change in date',
          () => {
            this.selectedDate = newValue
          },
          () => {
            this.chosenDate = this.selectedDate
          },
        );
      }
    },
    hasExpired(item) {
      let expired = this.hasTimerExpired(item)
      if (!expired) {
        const earliestSlotTime = this.getEarliestSlotTime(item)
        if (earliestSlotTime) {
          expired = getNow(this.timezone, true) >= (earliestSlotTime - (bookingBuffer * 60))
        }
      }
      return expired
    },
    hasTimerExpired(item) {
      const ends = 1 * _.get(item, 'payload.options.form.holdEndsAt', 0)
      if (ends) {
        return getNow().toSeconds() >= ends
      }
      return false

    },
    navigateToBookEvents() {
      window.location.assign(config.GROUP_EVENTS_URL)
    },
    addToLocalCart(data) {
      const prevCartId = this.input('cartId')
      if (prevCartId) {
        this.unsetLocalCartItem({date: prevCartId})
      }

      const date = parseDateTime(this.selectedDate).toISODate()
      this.setInput({cartId: date})
      const slots = _.clone(this.retrievedTimeslots, true)
      const inputs = _.clone(this.input(), true)
      this.setLocalCartItem({date, slots, inputs})
    },
    cleanSelectedTimeslots() {
      this.cleanTimeslots()
    },
    cleanExistingItems() {
      this.clearProductAccessories()
      this.cleanSelectedTimeslots()
      this.clearLocalCart()
      if (this.editMode) {
        this.removeExitingCartItems()
        this.editMode = false
      }
    },
    async removeExitingCartItems(id) {
      const mainItem = this.cartItem(id)
      this.editingId = null
      if (mainItem) {
        await this.removeCartItem({id})
        // const slots = mainItem.attributes && mainItem.attributes.form && mainItem.attributes.form.selectedSlots || {}
        // _.forOwn(slots, ({id}) => {
        //   this.removeCartItem({id})
        // })
      }
      await this.removeExitingAccessories()
    },
    async removeExitingAccessories() {
      const items = JSON.parse(JSON.stringify(this.productAccessories)) || {}
      _.forOwn(items, async ({cartId = null, id = null}) => {
          if (cartId) {
            await this.removeCartItem({id: cartId})
          }
      })
    },
    async addToCart(goto = true) {
      this.isAddingToCart = true
      const cartPage = 'page-cart'
      this.addToLocalCart()
      if (this.editingId) {
        await this.removeExitingCartItems(this.editingId)
      }
      await this.$nextTick()
      await this.addCartItems(this.proposedCart)
      this.setRaceEditItem(null)
      if (goto) {
        await this.$nextTick()
        this.goto(cartPage)
      } else {
        this.isAddingToCart = false
      }
    },
    showPrompts: _.debounce(function () {
      this.showBookGroupEventPrompt = this.moreThanRacersLimit
    }, 500),
    showHoursPrompts: _.debounce(function () {
      this.showHoursLimitPrompt = this.moreThanHoursLimit
    }, 500),

    async hydrateRacesFromCart(cartItem, cartItemComponent, cartComponent) {
      this.startHydratingData()
      const hasExpired = this.hasExpired(cartItem)
      this.freezeSlotRetrieval = true
      const {attributes, cartId}  = cartItem
      const {form: inputs} = attributes
      const selectedSlots = hasExpired ? {} : _.clone(inputs.selectedSlots)
      const otherInputs = _.clone(_.omit(inputs, ['selectedSlots']))
      await this.setInput(otherInputs)
      this.phoneConfirmation = _.get(otherInputs, 'contact.phone')
      this.emailConfirmation = _.get(otherInputs, 'contact.email')
      this.chosenDate = this.selectedDate
      const timeslots = await this.retrieveTimeslots(inputs.selectedDate)
      // this.freezeSlotRetrieval = true
      this.hydrateProductAccessories(attributes.accessories || {})

      await this.$nextTick()
        // this.setInput({selectedSlots})
      _.forOwn(selectedSlots, slot => {
        this.setTimeslot(slot)
      })
      // this.$forceUpdate()
      await this.$nextTick()
      if (hasExpired) {
        this.cleanSelectedTimeslots()
      }

      await this.$nextTick()
      // this.setRaceEditItem(null)
      this.startHydratingData(false)
      this.preventTimerResetInEditMode = false
    },

    hydrateProductAccessories(accessories) {
      let items = {}
      _.forOwn(accessories, (item, aId) => {
          const {cartId = null} = item
          let cartItem = null
          if (cartId && (cartItem = this.cartItem(cartId))) {
            this.addSock(aId, cartItem.payload.count, {cartId})
          }
      })
      return items
    },

    decreaseProposedSockCount() {
      this.sockProposedCount = Math.max(1, this.sockProposedCount - 1)
    },
    increaseProposedSockCount() {
      this.sockProposedCount = Math.min(this.raceSettings.max_accommodation, this.sockProposedCount + 1)
    },
    decreaseSelectedProposedSockCount(id) {
      const items = JSON.parse(JSON.stringify(this.productAccessories))
      const item = items[id] || null
      if (item) {
        item.count = Math.max(1, item.count - 1)
      }
      this.setProductAccessories(items)
    },
    increaseSelectedProposedSockCount(id) {
      const items = JSON.parse(JSON.stringify(this.productAccessories))
      const item = items[id] || null
      if (item) {
        item.count = Math.min(this.raceSettings.max_accommodation, item.count + 1)
      }
      this.setProductAccessories(items)
    },
    addSock(id, count, options) {
      const items = JSON.parse(JSON.stringify(this.productAccessories))
      const sock = this.socksProductsWithID[id] || this.sockProposed

      const item = {
        ...(items[id] || {id, count: 0, product: sock}),
        ...(options || {})
      }
      item.count = Math.min(this.raceSettings.max_accommodation, item.count + count)
      items[id] = item
      this.setProductAccessories(items)
    },
    removeSock({id}) {
      const items = JSON.parse(JSON.stringify(this.productAccessories))
      const item = items[id] || null
      if (item) {
        delete items[id]
      }
      this.setProductAccessories(items)
    },
    clearProductAccessories() {
      this.sockProposedCount = this.totalPlayers || 0
      this.setProductAccessories({})
    },

    async likeClick() {
      if (!this.cartNotReady) {
        await this.addToCart(false)
      }
    },
  }

}
